<template>
  <el-dialog
    @close="close()"
    :title="$t('ProjectSettings_SaveFeaturesDialog_Title')"
    :visible.sync="display"
    :modal-append-to-body="false"
    width="500px"
    center
  >
    <div class="center" v-if="hasChangedFeatures">
      <p>{{ $t('ProjectSettings_SaveFeaturesDialog_Message') }}</p>
      <div class="m-top-10">
        <ul>
          <li v-for="key in changedFeatures">
            <template v-if="isBooleanFeature(key)">
              {{ getFeatureTitle(key) }} - {{ getBooleanStatus(key) }}
            </template>
            <template v-else>
              UNKNOWN FEATURE FLAG TYPE
            </template>
          </li>
        </ul>
      </div>
    </div>
    <div class="center" :class="{ 'm-top-30': hasChangedFeatures }">
      <p>{{ $t('ProjectSettings_SaveFeaturesDialog_Question') }}</p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" plain @click="close()">
        {{ $t('ProjectSettings_Button_Cancel') }}
      </el-button>
      <el-button size="small" type="primary" @click="save()">
        {{ $t('ProjectSettings_Button_Confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MxaSaveFeaturesDialog',

  props: {
    featureDefs: {
      type: Object
    },
    featureProperties: {
      type: Object
    },
    featureValues: {
      type: Object
    },
    originalFeatureValues: {
      type: Object
    },
    changedFeatures: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      display: false
    }
  },

  computed: {
    hasChangedFeatures() {
      return this.changedFeatures.length > 0
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },
    getBooleanStatus(key) {
      return this.featureValues[key]
        ? this.$t('ProjectSettings_SaveFeaturesDialog_Enabled')
        : this.$t('ProjectSettings_SaveFeaturesDialog_Disabled')
    },
    getFeatureTitle(key) {
      if (!(key in this.featureProperties)) {
        throw new Error('tried to get non-existent property set')
      }

      if (!('title' in this.featureProperties[key])) {
        throw new Error('tried to get non-existent title property')
      }

      return this.$t(this.featureProperties[key].title)
    },
    isBooleanFeature(key) {
      if (!(key in this.featureDefs)) {
        throw new Error('tried to get non-existent feature definition')
      }

      if (!('type' in this.featureDefs[key])) {
        throw new Error('tried to get non-existent feature type')
      }

      return this.featureDefs[key].type === 'bool'
    },
    save() {
      this.$emit('save')
    },
    setVisible(value) {
      this.display = value
    }
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/project/components/MxaSaveFeaturesDialog.vue